export const Const = {
    borderRadiusSmall: "12px",
    borderRadiusMedium: "18px",
}

export const Color = {
    expired:   '#fcb65e80',
    finished:  '#679ec580',
    active:    '#ad79ce80',
    scheduled: '#7abd5c80',
    none: '#ffffffcc'
};
